const productDesc = document.querySelector(".js-product-description");
const productDescToggler = document.querySelector(".js-product-description-toggler");
const productDescToggleInput = document.querySelector("#product-description-toggle");
const productDescToggleText = productDescToggler?.querySelector(".product-description__toggle-text");

const observer = new ResizeObserver((entries) => {
	for (let entry of entries) {
		// entry.borderBoxSize or target.offsetHeight
		const height = entry.target.offsetHeight;

		if (height >= 700) {
			entry.target.classList.add("product-description--overflowing");
		} else {
			entry.target.classList.remove("product-description--overflowing");
			return;
		}
	}
});

if (productDesc) {
	observer.observe(productDesc);
}

const updateProductDescriptionToggle = () => {
	const isExpanded = productDescToggleInput?.checked === true;
	productDesc?.classList.toggle("is-expanded", isExpanded);

	if (productDescToggleText) {
		productDescToggleText.textContent = isExpanded ? "Read less" : "Read more";
	}
};

if (productDescToggleInput) {
	productDescToggleInput.addEventListener("change", updateProductDescriptionToggle);
	updateProductDescriptionToggle();
}
